'use strict';

exports.__esModule = true;
exports.focusRingVisible = exports.focusRing = exports.focusRingShadow = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  outline: none;\n  box-shadow: ', ';\n'], ['\n  outline: none;\n  box-shadow: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &:focus {\n    outline: none;\n  }\n  &:focus-visible {\n    ', '\n  }\n'], ['\n  &:focus {\n    outline: none;\n  }\n  &:focus-visible {\n    ', '\n  }\n']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// A11y-Fokus-Ring (2026-06, Welle-2-Fundament). Marken-konsistenter Tastatur-Fokus-
// Indikator als wiederverwendbares Mixin — extrahiert aus dem Button-:focus-visible-
// Block (ButtonStyled.js). secondaryLight (#35557b) + '66' (~40% Alpha) als 3px-Spread-
// box-shadow. Fallback-Kette wie ButtonStyled. Die Form-Controls der Folge-Welle 2
// konsumieren focusRing / focusRingVisible statt jeweils eigenem outline:none.

// box-shadow-Fragment des Rings — für Kompositionen, die ZUSÄTZLICH Elevation tragen
// (z.B. Button: `${focusRingShadow(theme)}, ${elevation}` in EINEM box-shadow, damit
// sich Ring und Schatten nicht gegenseitig überschreiben).
var focusRingShadow = exports.focusRingShadow = function focusRingShadow(theme) {
  return '0 0 0 3px ' + (theme && (theme.secondaryLight || theme.secondary) || '#35557b') + '66';
};

// Ring-only Mixin — für Elemente OHNE eigene Elevation (Inputs/Tabs/Checkboxen).
var focusRing = exports.focusRing = (0, _styledComponents.css)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return focusRingShadow(theme);
});

// Konditional: Ring NUR bei Tastatur-Fokus (:focus-visible), kein Ring bei Maus-Klick
// (:focus:not(:focus-visible)). Direkt auf Form-Controls anwendbar (Welle 2).
var focusRingVisible = exports.focusRingVisible = (0, _styledComponents.css)(_templateObject2, focusRing);

exports.default = focusRing;